var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-item-link-view',{attrs:{"loading":_vm.loading,"is-deleted":_vm.isDeleted,"contentSet":_vm.contentSet}})}
var staticRenderFns = []

export { render, staticRenderFns }